import { handleActions } from 'redux-actions';
import Immutable from 'immutable';
import { types as facebookInviteFriendsActionTypes } from 'actions/facebookInviteFriendsActions/facebookInviteFriendsActions';

export const initialState = Immutable.fromJS({
  friendsFilterText: '',
  selectedFriends: [],
  fbFriendsData: [],
  fbFriendsLoaded: false,
});

export const toggleFriendSelection = (state, action) => {
  let newState;

  const selectedFriends = state.get('selectedFriends');
  const indexOfSelectedFriend = selectedFriends.indexOf(action.id);

  if (indexOfSelectedFriend > -1) {
    newState = state.set('selectedFriends', selectedFriends.delete(indexOfSelectedFriend));
  } else {
    newState = state.set('selectedFriends', selectedFriends.push(action.id));
  }

  return newState;
};

export default handleActions({
  [facebookInviteFriendsActionTypes.UPDATE_AUTH_RESPONSE]: (state, action) =>
    state.merge({ fbAuthResponse: action.fbAuthResponse }),
  [facebookInviteFriendsActionTypes.UPDATE_FRIENDS_LIST]: (state, action) =>
    state
      .merge({ fbFriendsData: action.fbFriendsData })
      .merge({ fbFriendsLoaded: true }),
  [facebookInviteFriendsActionTypes.TOGGLE_FRIEND_SELECTION]: toggleFriendSelection,
  [facebookInviteFriendsActionTypes.REMOVE_FRIEND_SELECTION]: (state, action) => {
    const selectedFriends = state.get('selectedFriends');
    const indexOfSelectedFriend = selectedFriends.indexOf(action.id);
    return state.set('selectedFriends', selectedFriends.delete(indexOfSelectedFriend));
  },
  [facebookInviteFriendsActionTypes.FILTER_FRIENDS]: (state, action) =>
    state.merge({ friendsFilterText: action.friendsFilterText }),
}, initialState);



// WEBPACK FOOTER //
// ./reducers/facebookInviteFriendsReducers/facebookInviteFriendsReducers.js